<template>
  <b-form-group :state="state">
    <label class="form__label input-label" :for="id">{{ label }}</label>
    <div class="input-wrapper">
      <b-form-input
        :id="id"
        :type="showPassword ? 'text' : 'password'"
        :value="value"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :state="state"
        class="sing-up-input"
        @input="$emit('input', $event)"
      />
      <span class="material-icons toggle-password" @click="toggleShow">
        {{ showPassword ? "visibility_off" : "visibility" }}
      </span>
    </div>

    <template #invalid-feedback>
      <slot name="invalid-feedback"></slot>
    </template>
  </b-form-group>
</template>

<script>
export default {
  name: 'PasswordField',
  props: {
    value: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Password'
    },
    placeholder: {
      type: String,
      default: 'Enter Password'
    },
    autocomplete: {
      type: String,
      required: true
    },
    state: {
      type: [Boolean, null],
      default: null
    }
  },
  data () {
    return {
      showPassword: false
    }
  },
  methods: {
    toggleShow () {
      this.showPassword = !this.showPassword
    }
  }
}
</script>

<style scoped lang="scss">
.input-wrapper {
  position: relative;

  .form-control.is-invalid {
    background: none;
  }
}

.toggle-password {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  cursor: pointer;
  font-size: 20px;
  color: $fontColor2;
}
</style>
